import { useTranslation } from "lib/i18n/translation"
import DirectorProducts from "components/common/director-products"
import { Slider } from "components/common"
import { Product } from "components/selection/sub-selection"

const Availabilities = ({ director }) => {
	const { c } = useTranslation("common")

	return (
		<section>
			<h2 className="section-title icon-reel">{c("director-available-films")}</h2>
			<DirectorProducts directorId={director.id}>
				{products => (
					<Slider
						slides={products}
						slideComponent={Product}
						className="grid films"
					/>
				)}
			</DirectorProducts>
		</section>
	)
}

export default Availabilities
